/**
 * Shopify Contact Form Dynamic Logic
 * Assigns data-field attributes, handles conditional visibility and required state,
 * and uses `.is-required` class for visual asterisk via CSS
 */
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contact-form');
  const enquiryTypeSelect = form.querySelector('select[name="contact[Select Your Enquiry Type]"]');

  if (!form || !enquiryTypeSelect) return;

  // Map label text to field keys
  const FIELD_LABEL_MAP = {
    'Name': 'name',
    'Email': 'email',
    'Phone': 'phone',
    'Salon Name': 'salon_name',
    'Salon Suburb & Postcode': 'salon_suburb',
    'Country': 'country',
    'Message': 'message',
    'Company': 'company',
    'Product Name or Type': 'product_name',
    'Socials / Portfolio Link': 'socials'
  };

  // Assign data-field attributes
  Object.entries(FIELD_LABEL_MAP).forEach(([labelText, fieldKey]) => {
    const label = Array.from(form.querySelectorAll('label')).find(l =>
      l.textContent.trim().replace(/\s*\*$/, '') === labelText
    );

    if (!label) return;

    const input = form.querySelector(`#${label.getAttribute('for')}`);
    if (input) {
      input.setAttribute('data-field', fieldKey);
    }
  });

  // Field references
  const fields = {
    name: form.querySelector('[data-field="name"]'),
    email: form.querySelector('[data-field="email"]'),
    phone: form.querySelector('[data-field="phone"]'),
    salon_name: form.querySelector('[data-field="salon_name"]'),
    salon_suburb: form.querySelector('[data-field="salon_suburb"]'),
    country: form.querySelector('[data-field="country"]'),
    message: form.querySelector('[data-field="message"]'),
    company: form.querySelector('[data-field="company"]'),
    product_name: form.querySelector('[data-field="product_name"]'),
    socials: form.querySelector('[data-field="socials"]')
  };

  // Enquiry type logic
  const logic = {
    'Product Enquiry': ['name*', 'email*', 'product_name', 'message*'],
    'AU & NZ Stockist Enquiry': ['name*', 'salon_name*', 'salon_suburb*', 'email*', 'phone*', 'message*'],
    'International Stockist Enquiry': ['name*', 'company*', 'email*', 'country*', 'message*'],
    'Education Enquiry': ['name*', 'salon_name*', 'salon_suburb*', 'email*', 'phone', 'message*'],
    'Collaboration & Media Enquiries': ['name*', 'company', 'socials', 'phone', 'email*', 'message*'],
    'Other': ['name*', 'email*', 'message*']
  };

  const updateFormFields = () => {
    const selected = enquiryTypeSelect.value;
    const requiredFields = logic[selected] || [];

    Object.entries(fields).forEach(([key, field]) => {
      if (!field) return;

      const wrapper = field.closest('.col-span-2');
      const isRequired = requiredFields.includes(`${key}*`);
      const isVisible = requiredFields.some(name => name.startsWith(key));

      // Visibility
      wrapper.style.display = isVisible ? '' : 'none';

      // Required state
      field.required = isRequired;
      field.setAttribute('aria-required', isRequired ? 'true' : 'false');

      // Visual asterisk via CSS
      wrapper.classList.toggle('is-required', isRequired);
    });
  };

  enquiryTypeSelect.addEventListener('change', updateFormFields);

  if (enquiryTypeSelect.value === 'Product Enquiry') {
    updateFormFields();
  }
});